import { format } from 'timeago.js';

function dateFormat(time, format) {
    const date = new Date(time);
    const o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds(),
        "q+": Math.floor((date.getMonth() + 3) / 3),
        S: date.getMilliseconds()
    };
    if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
    }
    return format;
}

class TimeSpan {
    constructor(betweenTime = 1000 * 60, maxTimeago = 1000 * 60 * 60) {
        this.startTimeStamp = 0;
        this.language = "zh_CN";
        this.betweenTime = betweenTime;
        this.maxTimeago = maxTimeago;
    }
    format(timestamp) {
        if (!timestamp) {
            return null;
        }
        let timeInfoNode = null;
        if (timestamp - this.startTimeStamp > this.betweenTime) {
            timeInfoNode =
                new Date().getTime() - timestamp < this.maxTimeago
                    ? format(timestamp, this.language)
                    : dateFormat(timestamp, "yyyy年MM月dd日 hh:mm");
        }
        this.startTimeStamp = timestamp;
        return timeInfoNode;
    }
}

export default TimeSpan;



// WEBPACK FOOTER //
// ../chat-timespan/dist/index.esm.js